<template>
  <nav>
    <div v-show="is_notify" class="notification">
      <ul style="list-style: none;">
        <li
          style="background-color: #63f809;"
          v-for="notify in logs_not_seen"
          :key="notify.id"
        >
          <div style="font-size: 19px;font-weight: bold">
            <span
              style="float:left;font-size: 12px;font-weight: normal;color:blue"
              >{{ notify.created_at }}</span
            >{{ notify.title }}
          </div>

          <div>{{ notify.body }}</div>
          <hr />
        </li>
        <li v-for="notify in logs_seen" :key="notify.id">
          <div style="font-size: 19px;font-weight: bold">
            <span
              style="float:left;font-size: 12px;font-weight: normal;color:blue"
              >{{ notify.created_at }}</span
            >{{ notify.title }}
          </div>

          <div>{{ notify.body }}</div>
          <hr />
        </li>
      </ul>
    </div>
    <v-toolbar dark color="orange" app dir="rtl">
      <!-- <v-toolbar-side-icon  >
      </v-toolbar-side-icon> -->
      <v-avatar @click.prevent="drawer = !drawer" size="100">
        <img src="../../../public/images/color.png" alt="" />
      </v-avatar>
      <v-spacer></v-spacer>
      <p
        style=" font-size: 20px;color: black;font-weight: bold; text-shadow: 2px 1px 2px white;font-family: 'Aref Ruqaa' ;"
      >
        {{ getName }}
      </p>

      <!-- <v-toolbar-title class="white--text">Title</v-toolbar-title> -->

      <v-spacer></v-spacer>

      <v-badge color="blue">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" large color="blue" @click="$router.push('/')">
              home
            </v-icon>
          </template>
          <span>الصفحة الرئيسية</span>
        </v-tooltip>
      </v-badge>

      <v-badge color="red">
        <template v-slot:badge>
          <span>{{ orders_not_seen.length }}</span>
        </template>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              large
              color="grey"
              @click="$router.push('/SellFatwora')"
            >
              list
            </v-icon>
          </template>
          <span> اوامر التوريد من المندوب والمشرف </span>
        </v-tooltip>
      </v-badge>

      <v-badge color="red">
        <template v-slot:badge>
          <span>{{ tahsils.length }}</span>
        </template>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              large
              color="green"
              @click="$router.push('/Tahsilat')"
            >
              money
            </v-icon>
          </template>
          <span>طلبات التحصيل من المندوب</span>
        </v-tooltip>
      </v-badge>

      <v-badge color="red">
        <template v-slot:badge>
          <span>{{ fatworas_tanfiz.length }}</span>
        </template>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              large
              color="black"
              @click="$router.push('/TanfizFatworas')"
            >
              book
            </v-icon>
          </template>
          <span>فواتير قيد التنفيذ</span>
        </v-tooltip>
      </v-badge>

      <v-badge color="red">
        <template v-slot:badge>
          <span>{{ fatworas_sarf_store.length }}</span>
        </template>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              large
              color="blue"
              @click="$router.push('/SarfFromStore')"
            >
              book
            </v-icon>
          </template>
          <span>فواتير قيد الصرف من المخزن</span>
        </v-tooltip>
      </v-badge>

      <v-badge color="red">
        <template v-slot:badge>
          <span>{{ fatworas_taslim.length }}</span>
        </template>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              large
              color="yellow"
              @click="$router.push('/TaslimFatworas')"
            >
              book
            </v-icon>
          </template>
          <span>فواتير قيد التسليم</span>
        </v-tooltip>
      </v-badge>

      <v-badge color="red">
        <template v-slot:badge>
          <span>{{ fatworas_solmt.length }}</span>
        </template>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              large
              color="grey"
              @click="$router.push('/SolmtFatworas')"
            >
              book
            </v-icon>
          </template>
          <span>فواتير قيد قبول العميل واستلامها </span>
        </v-tooltip>
      </v-badge>

      <v-badge v-model="show_notification" color="cyan">
        <template v-slot:badge>
          <span>{{ logs_not_seen.length }}</span>
        </template>
        <v-icon large @click="see_notify" color="grey lighten-1"
          >notification_important</v-icon
        >
      </v-badge>

      <v-badge color="red">
        <template v-slot:badge>
          <span>{{ sms_not_seen_no.length }}</span>
        </template>
        <v-icon large color="grey" @click="see_sms">
          sms
        </v-icon>
      </v-badge>

      <v-badge color="red">
        <v-icon large color="grey" @click="logout">
          person
        </v-icon>
      </v-badge>
 
    </v-toolbar>

    <v-navigation-drawer app v-model="drawer" class="orange" right width="360">
      <v-avatar
        :tile="tile"
        :size="avatarSize"
        color="grey lighten-4"
        class="my-3"
        @click="change_info"
        style="cursor:pointer"
      >
        <img src="../../../public/images/user.jpg" alt="avatar" />
      </v-avatar>
      <br />
      <center>{{ user && user != null && user != "" ? user.name : "" }}</center>
      <v-list dir="rtl">
        <v-list-group
          v-for="item in list"
          :key="item.title"
          v-model="item.active"
          :prepend-icon="item.action"
          right
          dir="rtl"
          @click="add_items(item)"
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title style="font-size: 20px;font-weight: bold;">{{
                item.title
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <!--   
              <v-list-tile 
                v-for="subItem in item.items"
                :key="subItem.title"
               router :to="subItem.route"
               class="mr-4"
              style="background-color:#FAC029"
              v-if="drawer"
              >
                <v-list-tile-action>
                  <v-icon>{{ subItem.action }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title style="font-size: 18px;">{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>
  
              </v-list-tile> -->
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <div
      class="new_items_upper"
      style="z-index:999999999"
      v-if="drawer && item.items && item.items.length > 0"
    >
      <ul class="new_items" style="width:100%;padding:0;margin: 0;">
        <li
          v-for="ii in item.items"
          :key="ii.route"
          v-if="check_per(ii.permission)"
          :style="$route.path == ii.route ? { backgroundColor: '#d5a948' } : ''"
        >
          <router-link :to="ii.route">{{ ii.title }}</router-link>
        </li>
      </ul>
    </div>
    <v-dialog v-model="dialog" max-width="700px" dir="rtl" align="right">
      <v-card dark>
        <v-card-title>
          <span class="headline"> تعديل البيانات</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm8 md8 style="margin :17px">
                  <v-text-field
                    type="password"
                    v-model="old_password"
                    label=" كلمة السر القديمة"
                  ></v-text-field>
                  <v-text-field
                    type="password"
                    v-model="new_password"
                    label=" كلمة السر الجديدة "
                  ></v-text-field>
                  <v-text-field
                    type="password"
                    v-model="confirm_password"
                    label=" تأكيد كلمة السر"
                  ></v-text-field>
                  <v-btn @click="change_password"> تغير كلمة السر</v-btn>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <img :src="imageUrl" height="150" v-if="imageUrl" />
                  <v-text-field
                    label="Select Image"
                    @click="pickFile"
                    v-model="imageName"
                    prepend-icon="attach_file"
                  ></v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="image"
                    accept="image/*"
                    @change="onFilePicked"
                  />
                  <v-btn> تغير الصورة </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </nav>
</template>

<script>
import {
  see_notify,
  notification_sms,
  change_password
} from "../config/apiRoute.js";
import { names } from "../config/routeNames.js";
export default {
  data() {
    return {
      user: [],
      permissions: [],
      names: [],
      drawer: false,
      is_notify: false,
      showme: false,
      item: [],

      mini: false,
      right: null,
      slider: 56,
      tile: false,
      show_notification: true,
      logs_not_seen: [],
      logs_seen: [],
      notify_not_sent: [],
      sms_not_seen_no: [],
      orders_not_seen: [],
      tahsils: [],
      fatworas_tanfiz: [],
      fatworas_sarf_store: [],
      fatworas_taslim: [],
      fatworas_solmt: [],
      old_password: "",
      new_password: "",
      confirm_password: "",
      dialog: false,
      title: "Image Upload",
      imageName: "",
      imageUrl: "",
      imageFile: "",
      list: [
        {
          action: "dashboard",
          title: " التحكم الكامل",
          permission: "control",
          items: [
            // { title: "الوظائف", route: "/Jobs", action: "group" },
            {
              title: "الفروع",
              route: "/Branches",
              action: "group",
              permission: "branches"
            },
            {
              title: "المناطق",
              route: "/Regions",
              action: "group",
              permission: "regions"
            },

            // { title: 'حالات السداد', 'route':'/SadadStatus' ,action: 'group'},
            {
              title: "المستخدمين",
              route: "/users",
              action: "group",
              permission: "users"
            },
            {
              title: "المستخدمين العملاء",
              route: "/ClientUsers",
              action: "group",
              permission: "client_users"
            },
            {
              title: "العملاء",
              route: "/clients",
              action: "perm_identity",
              permission: "clients"
            },
            {
              title: "تصنيف العملاء",
              route: "/ClientClasses",
              action: "perm_identity",
              permission: "clients"
            },
            {
              title: "الموردين",
              route: "/Importers",
              action: "import_export",
              permission: "importers"
            },
            {
              title: "المخازن",
              route: "/stores",
              action: "store",
              permission: "stores"
            },
            {
              title: "المجموعات",
              route: "/groups",
              action: "group_work",
              permission: "groups"
            },
            {
              title: "الاصناف",
              route: "/items",
              action: "motorcycle",
              permission: "items"
            },
            {
              title: "شرائح الاصناف",
              route: "/ItemPriceLayer",
              action: "motorcycle",
              permission: "items"
            },
            {
              title: "العروض",
              route: "/OfferItems",
              action: "motorcycle",
              permission: "offers"
            },
            // {
            //   title: "شئون الموظفين",
            //   route: "/employees",
            //   action: "record_voice_over"
            // },
            {
              title: "الخزينة",
              route: "/Khazina",
              action: "record_voice_over",
              permission: "khazinas"
            },
            {
              title: "البنوك",
              route: "/Banks",
              action: "record_voice_over",
              permission: "banks"
            },
            {
              title: "انواع المصروفات",
              route: "/Money",
              action: "record_voice_over",
              permission: "masrofat_types"
            },
            // { title: 'انواع السداد', 'route':'/SadadTypes' ,action: 'record_voice_over'},
            // { title: "السيارات", route: "/Cars", action: "record_voice_over", permission:'cars' },

            {
              title: " ربط موظف بمخزن",
              route: "/EmployerStore",
              action: "school",
              permission: "store_employer_link"
            },
            {
              title: "بداية للاصناف في المخازن",
              route: "/StoreItemStart",
              action: "school",
              permission: "store_item_start"
            }
          ]
        },
        {
          action: "storefront",
          title: " عمليات المخازن ",
          permission: "stores_operation",
          // active: true,
          items: [
            {
              title: "فواتير التحويلات   ",
              route: "/StoreTransferFatworas",
              action: "school",
              permission: "transfer_fatworas"
            },
            {
              title: "تحويلات المخازن",
              route: "/StoreTransfer",
              action: "school",
              permission: "store_transfer"
            },
            {
              title: "فواتير التحويلات من والتعديل عليها ",
              route: "/StoreTransferFrom",
              action: "school",
              permission: "store_transfer"
            },
            {
              title: "فواتير التحويلات الي والتأكيد عليها",
              route: "/StoreTransferTo",
              action: "school",
              permission: "store_transfer"
            },
            {
              title: " قبول المندوب والصرف من المخزن",
              route: "/TaslimFatworas",
              action: "school",
              permission: "taslim_fatwora"
            },
            {
              title: "التاكيد علي فاتورة المرتجعات",
              route: "/Rebackfatworas",
              action: "school",
              permission: "reback_fatworas"
            },
            {
              title: " كارت صنف",
              route: "/SanfCard",
              action: "school",
              permission: "sarf_card"
            },
            {
              title: "قيمةالمخزون",
              route: "/MakhzonCost",
              action: "school",
              permission: "store_item_start"
            }
          ]
        },
        {
          action: "ballot",
          title: "المبيعات",
          permission: "sales",
          items: [
            {
              title: "صفحة المشرف وأمر التوريد",
              route: "/OrderConfirmation",
              action: "orders",
              permission: "supervisor_page"
            },
            {
              title: "أوامر التوريد",
              route: "/SellFatwora",
              action: "orders",
              permission: "orders"
            },
            {
              title: " فواتير قيد التنفيذ",
              route: "/TanfizFatworas",
              action: "school",
              permission: "tanfiz_fatworas"
            },
            {
              title: "قبول موظف المخزن الاذن ",
              route: "/SarfFromStore",
              action: "school",
              permission: "sarf_from_stores"
            },
            {
              title: " قبول العميل الفاتورة واستلامها",
              route: "/SolmtFatworas",
              action: "school",
              permission: "solmt_fatworas"
            },
            {
              title: "مرتجع البيع",
              route: "/SellFatworaReback",
              action: "school",
              permission: "sell_reback"
            },
            {
              title: "مرتجع البيع العام",
              route: "/PublicRebackFatwora",
              action: "school",
              permission: "global_reback"
            },
            {
              title: "الفواتير النهائية",
              route: "/FinalFatworas",
              action: "school",
              permission: "final_fatworas"
            }
          ]
        },
        {
          action: "insert_invitation",
          title: "المشتريات",
          permission: "buy",
          items: [
            {
              title: "فاتورة مشتريات",
              route: "/BuyFatwora",
              action: "school",
              permission: "buy_fatworas"
            },
            {
              title: "مرتجع مشتريات",
              route: "/BuyFatworaReback",
              action: "school",
              permission: "buy_fatwora_reback"
            },
            {
              title: "تأكيد مشتريات",
              route: "/BuyFatworaConfirmation",
              action: "school",
              permission: "buy_confirmation"
            }
          ]
        },
        // {
        //   action: 'school',
        //   title: 'السيارات',
        //   items: [
        //     { title: 'انواع المصروفات', 'route':'/',action: 'school' },
        //     { title: 'اضافة مصروف', 'route':'/',action: 'school' },

        //   ]
        // },
        {
          action: "money",
          title: "الخزينة",
          permission: "khazinas",
          items: [
            {
              title: "سداد العملاء",
              route: "/ClientSadad",
              action: "school",
              permission: "client_sadad"
            },
            {
              title: "سداد الموردين",
              route: "/ImporterSadad",
              action: "school",
              permission: "importer_sadad"
            },
            {
              title: "خصم العملاء",
              route: "/ClientKhasm",
              action: "school",
              permission: "client_khasm"
            },
            {
              title: "ايداع مبلغ",
              route: "/Deposit",
              action: "school",
              permission: "khazina_deposit"
            },
            {
              title: "سحب مبلغ",
              route: "/Withdrew",
              action: "school",
              permission: "khazina_withdrew"
            },
            {
              title: " تحويل من خزينة لأخري",
              route: "/KhaznaTransfer",
              action: "school",
              permission: "khazina_transfer"
            },
            {
              title: "مصروفات",
              route: "/Masrofat",
              action: "school",
              permission: "masrofat"
            },
            {
              title: "عهدة",
              route: "/Ohda",
              action: "school",
              permission: "ohda"
            }
          ]
        },
        {
          action: "business",
          title: "البنوك",
          permission: "banks",
          items: [
            // { title: "القبض والدفع", route: "/", action: "school" },
            // { title: "حسابات بنكية ", route: "/", action: "school" },
            // { title: "معاملات بنكية ", route: "/", action: "school" },
            // { title: " قبول ورفض  ", route: "/", action: "school" }
            {
              title: "  ايداع بنك  ",
              route: "/BankDeposite",
              action: "school",
              permission: "bank_deposit"
            },
            {
              title: "  سحب بنك  ",
              route: "/BankWithdrew",
              action: "school",
              permission: "bank_withdrew"
            },
            {
              title: "  تحويل بنك  ",
              route: "/BankTransfer",
              action: "school",
              permission: "bank_transfer"
            },
            {
              title: "  شيكات  ",
              route: "/BankCheque",
              action: "school",
              permission: "cheques"
            }
          ]
        },
        {
          action: "print",
          title: "الطباعة",
          permission: "banks",
          items: [
            {
              title: "فاتورة ضريبية",
              route: "/TaxFatwora",
              action: "school",
              permission: "TaxFatwora"
            }
          ]
        },
        {
          action: "supervisor_account",
          title: "الموارد البشرية",
          permission: "hr",
          items: [
            // { title: "ادارات واقسام ", route: "/", action: "school" },
            {
              title: "الموظفين",
              route: "/Employers",
              action: "group",
              permission: "employers"
            },
            {
              title: "العمولات",
              route: "/EmployersOmola",
              action: "group",
              permission: "omolas"
            },
            {
              title: "البدلات",
              route: "/EmployerBadalat",
              action: "group",
              permission: "badalat"
            },
            {
              title: "الحوافز",
              route: "/EmployerHafez",
              action: "group",
              permission: "hafez"
            },
            {
              title: "الخصومات",
              route: "/EmployerKhasm",
              action: "group",
              permission: "khasm"
            },
            {
              title: "السلف",
              route: "/EmployerSolfa",
              action: "group",
              permission: "solfa"
            },
            // { title: "المرتبات", route: "/EmployerSalary", action: "group", permission:'salary' },
            {
              title: " المرتبات والحوافز",
              route: "/SalaryInput",
              action: "group",
              permission: "salary_input"
            },
            {
              title: " اجازات غياب ",
              route: "/Vacancy",
              action: "school",
              permission: "vacancy"
            },
            {
              title: " حضور وانصراف ",
              route: "/Attends",
              action: "school",
              permission: "attends"
            },
            {
              title: " تقرير حضور وانصراف  ",
              route: "/AttendReport",
              action: "school",
              permission: "attends"
            },
            {
              title: "تارجت المندوبين",
              route: "/MandobTargetInput",
              action: "school",
              permission: "mandob_target"
            },
            {
              title: " الحسابات والارباح",
              route: "/Profit",
              action: "school",
              permission: "all_profit"
            },
            {
              title: " الحسابات والارباح لكل صنف",
              route: "/ProfiItem",
              action: "school",
              permission: "item_profit"
            }
            // { title: " حركات موظفين ", route: "/", action: "school" }
          ]
        },
        {
          action: "notes",
          title: " كشوف الحسابات",
          permission: "account_note",
          items: [
            {
              title: "حساب عميل مفصل",
              route: "/ClientDetailAccount",
              action: "group",
              permission: "client_detail_account"
            },
            {
              title: "حساب عميل مختصر",
              route: "/ClientAccount",
              action: "group",
              permission: "client_account"
            },
            {
              title: "حساب مورد",
              route: "/ImporterAccount",
              action: "group",
              permission: "importer_account"
            }
          ]
        },
        {
          action: "note",
          title: "تقارير المبيعات",
          permission: "report_sales",
          items: [
            {
              title: " مبيعات مندوب من إلي  ",
              route: "/MandobSalesReport",
              action: "school",
              permission: "mandob_sales_report"
            },
            {
              title: " مبيعات مندوب بنوع العميل ",
              route: "/MandobClientTypeReport",
              action: "school",
              permission: "mandob_client_type_report"
            },
            {
              title: "  مبيعات مندوب بالصنف ",
              route: "/MandobItemReport",
              action: "school",
              permission: "mandob_item_report"
            },
            {
              title: "  سداد العملاء بالمندوب ",
              route: "/MandobClientSadadReport",
              action: "school",
              permission: "mandob_client_sadad_report"
            },
            {
              title: "  مديونية العملاء بالمندوب ",
              route: "/MandobClientMadioniaReport",
              action: "school",
              permission: "mandob_client_madionia_report"
            },
            {
              title: " تقرير عام مبيعات صنف",
              route: "/ItemSalesReport",
              action: "school",
              permission: "item_sales_report"
            },
            {
              title: " مبيعات صنف بنوع العميل ",
              route: "/ItemClientTypeReport",
              action: "school",
              permission: "item_client_type_report"
            },
            {
              title: "متوسطات مبيعات اصناف ",
              route: "/ItemSalesAverageReport",
              action: "school",
              permission: "item_client_type_report"
            },
            {
              title: "تقرير مسحوبات عملاء حسب التصنيف",
              route: "/ClientSalesValueReport",
              action: "school",
              permission: "item_client_type_report"
            },
            {
              title: "تقرير متوسط سدادات ومبيعات عملاء",
              route: "/ClientSadadSalesAverageReport",
              action: "school",
              permission: "item_client_type_report"
            }

            // { title: " المخازن ", route: "/", action: "school" },
            // { title: "  المندوبين ", route: "/", action: "school" },
            // { title: " المبيعات", route: "/", action: "school" },
            // { title: " كارت صنف", route: "/", action: "school" },
            // { title: "  الاكثر والاقل", route: "/", action: "school" },
            // { title: "   الاصناف الراكدة", route: "/", action: "school" },
            // { title: "   مبيعات يومية ", route: "/", action: "school" },
            // { title: "    فواتير المشتريات ", route: "/", action: "school" },
            // { title: "  مشتريات لكل صنف ", route: "/", action: "school" },
            // { title: "  مشتريات ومبيعات مجمع ", route: "/", action: "school" },
            // { title: "  طباعة فاتورة ", route: "/", action: "school" },
            // { title: "  بيانات العملاء ", route: "/", action: "school" },
            // { title: "  بيانات الموردين ", route: "/", action: "school" },
            // { title: "  حسابات العملاء ", route: "/", action: "school" },
            // { title: "  حسابات الموردين ", route: "/", action: "school" },
            // { title: "  انظمة اقساط العملاء ", route: "/", action: "school" },
            // { title: " العملاء الراكدون ", route: "/", action: "school" },
            // { title: "  الموردين الراكدون ", route: "/", action: "school" },
            // { title: "  العملاء الأكثر حركة ", route: "/", action: "school" },
            // { title: "  الموردين الأكثر حركة ", route: "/", action: "school" }
          ]
        },
        {
          action: "note",
          title: "تقارير المخازن",
          permission: "report_stores",
          items: [
            {
              title: "الاصناف المحولة للمخازن ",
              route: "/StoreItemTransferReport",
              action: "school",
              permission: "store_item_transfer_report"
            },
            {
              title: " صنف محول للمخازن ",
              route: "/StoreOneItemTransferReport",
              action: "school",
              permission: "store_one_item_transfer_report"
            },
            {
              title: " حركة مخزن من الي",
              route: "/StoreMovementReport",
              action: "school",
              permission: "store_movement_report"
            },
            {
              title: " حركة جميع المخازن من الي",
              route: "/StoreMovementAllReport",
              action: "school",
              permission: "store_movement_all_report"
            },
            {
              title: " جرد مخزن",
              route: "/StoreGard",
              action: "school",
              permission: "store_gard"
            }
            // {
            //   title: " جرد مخزن مفصل",
            //   route: "/StoreGardDetailReport",
            //   action: "school"
            // }
          ]
        },
        {
          action: "note",
          title: "تقارير الخزينة",
          permission: "report_khazina",
          items: [
            {
              title: "سداد العملاء من إلي ",
              route: "/KhazinaClientSadadReport",
              action: "school",
              permission: "khazina_client_sadad_report"
            },
            {
              title: " تقرير شامل للخزينة ",
              route: "/KhazinaInputDetailReport",
              action: "school",
              permission: "khazina_input_detail_report"
            },
            {
              title: "تقرير المصروفات من الي",
              route: "/MasrofAllReport",
              action: "school",
              permission: "masrof_all_report"
            },
            {
              title: " تقريرالمصروفات بنوع المصروف ",
              route: "/MasrofWithTypeReport",
              action: "school",
              permission: "masrof_with_type_report"
            },
            {
              title: "ايرادات الخزينة ",
              route: "/KhazinaInputReport",
              action: "school",
              permission: "khazina_input_report"
            }
          ]
        },
        {
          action: "note",
          title: "تقارير الادارة",
          permission: "management_report",
          items: [
            {
              title: "تقرير عادي فرع ",
              route: "/BranchSalesReport",
              action: "school",
              permission: "barnch_sales_report"
            },
            {
              title: "تقرير مختصر فرع ",
              route: "/BranchSalesReportShort",
              action: "school",
              permission: "barnch_sales_report"
            },
            {
              title: "تقرير شامل فرع ",
              route: "/BranchSalesReportAllDetails",
              action: "school",
              permission: "barnch_sales_report"
            },
            {
              title: "تقرير شامل شركة",
              route: "/CompanySalesReport",
              action: "school",
              permission: "company_sales_report"
            },
            {
              title: "تقرير مديونيات فرع",
              route: "/BranchMadioniaReport",
              action: "school",
              permission: "branch_madionia_report"
            },
            {
              title: "تقرير مديونيات شركة",
              route: "/CompanyMadioniaReport",
              action: "school",
              permission: "company_madionia_report"
            },
            {
              title: " تتبع الحركات للسيستم",
              route: "/UserBehaviorReport",
              action: "school",
              permission: "user_behavior_report"
            }
          ]
        },
        {
          action: "note",
          title: "تقارير الموظفين ",
          permission: "hr_report",
          items: [
            {
              title: " مرتبات الموظفين ",
              route: "/EmployerSalaryReport",
              action: "school",
              permission: "employer_salary_report"
            },
            {
              title: " عمولات المندوبين ",
              route: "/EmployerOmolaReport",
              action: "school",
              permission: "employer_omola_report"
            },
            {
              title: " تارجت المندوبين",
              route: "/MandobTarget",
              action: "school",
              permission: "employer_omola_report"
            },
            {
              title: "تقارير المهام المسندة",
              route: "/TasksReport",
              action: "school",
              permission: "employer_omola_report"
            }
          ]
        },
        {
          action: "note",
          title: "تقارير قوائم العملاء",
          permission: "hr_report",
          items: [
            {
              title: "قائمة العملاء بالفرع ",
              route: "/ClientsWithBranch",
              action: "school",
              permission: "employer_salary_report"
            },
            {
              title: "قائمة العملاء بالمندوب ",
              route: "/ClientsWithMandob",
              action: "school",
              permission: "employer_omola_report"
            },
            {
              title: "قائمة العملاء الجدد",
              route: "/ClientsWithNew",
              action: "school",
              permission: "employer_omola_report"
            },
            {
              title: "قائمة العملاء بالمنطقة",
              route: "/ClientsWithRegion",
              action: "school",
              permission: "employer_omola_report"
            }
          ]
        },
        {
          action: "note",
          title: "تقارير الموردين ",
          permission: "import_report",
          items: [
            {
              title: " سداد موردين من الي ",
              route: "/KhazinaImporterSadadReport",
              action: "school",
              permission: "khazina_importer_sadad_report"
            },
            {
              title: " مشتريات عام بالصنف   ",
              route: "/ItemBuyReport",
              action: "school",
              permission: "item_buy_report"
            }
          ]
        },
        {
          action: "note",
          title: "تقارير المرتجعات",
          permission: "reback_report",
          items: [
            {
              title: "مرتجع مبيعات حسب العملاء",
              route: "/RebackSellAll",
              action: "school",
              permission: "reback_sell_all"
            },
            {
              title: "مرتجع مبيعات حسب الفاتورة",
              route: "/RebackSellAllByFatwora",
              action: "school",
              permission: "reback_sell_all"
            },
            {
              title: "مرتجع شراء عام",
              route: "/RebackBuyAll",
              action: "school",
              permission: "reback_buy_all"
            },
            {
              title: "مرتجع الشراء بالصنف",
              route: "/RebackItemBuyReport",
              action: "school",
              permission: "reback_item_buy_report"
            },
            {
              title: "مرتجع عميل",
              route: "/RebackClientReport",
              action: "school",
              permission: "reback_client_report"
            },
            {
              title: "مرتجعات بالمندوب",
              route: "/RebackMandobReport",
              action: "school",
              permission: "reback_mandob_report"
            },
            {
              title: "مرتجع مبيعات بالصنف",
              route: "/RebackItemReport",
              action: "school",
              permission: "reback_item_report"
            },
            {
              title: "مرتجعات بالمورد",
              route: "/RebackImporterReport",
              action: "school",
              permission: "reback_importer_report"
            }
          ]
        },
        {
          action: "note",
          title: "صفحات خاصة بالمندوب",
          permission: "",
          items: [
            {
              title: "طلبات اضافة عميل",
              route: "/AddNewClient",
              action: "school",
              permission: "AddNewClient"
            },
            {
              title: "زيارات المندوبين",
              route: "/mandobVisits",
              action: "school",
              permission: "mandobVisits"
            },
            {
              title: "المهام المسندة",
              route: "/Tasks",
              action: "school",
              permission: "Tasks"
            },
            {
              title: "تحصيلات المندوب",
              route: "/Tahsilat",
              action: "school",
              permission: "Tahsilat"
            },
            {
              title: "تتبع",
              route: "/Track",
              action: "school",
              permission: "Track"
            },
            {
              title: "تحصيلات مندوب من الي  ",
              route: "/TahsilatReport",
              action: "school",
              permission: "khazina_input_report"
            }
          ]
        },
        {
          action: "note",
          title: "السيريال",
          permission: "",
          items: [
            {
              title: "اضافة سيريال",
              route: "/AddSerial",
              action: "school",
              permission: "items"
            },
            {
              title: "تتبع سيريال",
              route: "/TrackSerial",
              action: "school",
              permission: "items"
            },
         
          ]
        }
      ]
    };
  },
  mounted() {},
  methods: {
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("permission");
      localStorage.removeItem("userAuth");

      this.$router.push("/login");
    },
    see_notify() {
      this.is_notify = !this.is_notify;
      var frmData = new FormData();
      see_notify(frmData).then(response => {});
    },
    see_sms() {
      // var frmData = new FormData();
      // see_sms(frmData).then(response => {
      //   this.sms_not_seen();
      this.$router.push("/Chat");

      // });
    },
    change_info() {
      this.dialog = true;
    },

    //start change photo
    pickFile() {
      this.$refs.image.click();
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },

    change_password() {
      if (this.new_password == this.confirm_password) {
        var frmData = new FormData();
        frmData.append("old_password", this.old_password);
        frmData.append("new_password", this.new_password);
        change_password(frmData).then(response => {
          if (response.data == true) {
            this.$swal("Success", "تم تغيير كلمة السر بنجاح", "success");
          } else {
            this.$swal(
              "Error",
              "كلمة السر القديمة غير صحيحة يرجي التأكد  ",
              "error"
            );
          }
        });
      } else {
        this.$swal("Error", "كلمة السر غير متطابقة ", "error");
      }
    },
    add_items(item) {
      if (item.title == this.item.title) {
        this.item = [];
      } else {
        this.item = item;
      }
    }

    //end  change photo
  },
  computed: {
    avatarSize() {
      return `${this.slider}px`;
    },
    check_per() {
      return function(val) {
        if (val == "branches") {
          let x =
            this.user.type == "1" || this.permissions.branches == "1"
              ? true
              : false;
          return x;
        } else if (val == "regions") {
          let x =
            this.user.type == "1" || this.permissions.regions == "1"
              ? true
              : false;
          return x;
        } else if (val == "users") {
          let x =
            this.user.type == "1" || this.permissions.users == "1"
              ? true
              : false;
          return x;
        } else if (val == "clients") {
          let x =
            this.user.type == "1" || this.permissions.clients == "1"
              ? true
              : false;
          return x;
        } else if (val == "importers") {
          let x =
            this.user.type == "1" || this.permissions.importers == "1"
              ? true
              : false;
          return x;
        } else if (val == "stores") {
          let x =
            this.user.type == "1" || this.permissions.stores == "1"
              ? true
              : false;
          return x;
        } else if (val == "groups") {
          let x =
            this.user.type == "1" || this.permissions.groups == "1"
              ? true
              : false;
          return x;
        } else if (val == "items") {
          let x =
            this.user.type == "1" || this.permissions.items == "1"
              ? true
              : false;
          return x;
        } else if (val == "khazinas") {
          let x =
            this.user.type == "1" || this.permissions.khazinas == "1"
              ? true
              : false;
          return x;
        } else if (val == "banks") {
          let x =
            this.user.type == "1" || this.permissions.banks == "1"
              ? true
              : false;
          return x;
        } else if (val == "masrofat_types") {
          let x =
            this.user.type == "1" || this.permissions.masrofat_types == "1"
              ? true
              : false;
          return x;
        } else if (val == "cars") {
          let x =
            this.user.type == "1" || this.permissions.cars == "1"
              ? true
              : false;
          return x;
        } else if (val == "store_employer_link") {
          let x =
            this.user.type == "1" || this.permissions.store_employer_link == "1"
              ? true
              : false;
          return x;
        } else if (val == "store_item_start") {
          let x =
            this.user.type == "1" || this.permissions.store_item_start == "1"
              ? true
              : false;
          return x;
        } else if (val == "store_transfer") {
          let x =
            this.user.type == "1" || this.permissions.store_transfer == "1"
              ? true
              : false;
          return x;
        } else if (val == "transfer_fatworas") {
          let x =
            this.user.type == "1" || this.permissions.transfer_fatworas == "1"
              ? true
              : false;
          return x;
        } else if (val == "taslim_fatwora") {
          let x =
            this.user.type == "1" || this.permissions.taslim_fatwora == "1"
              ? true
              : false;
          return x;
        } else if (val == "reback_fatworas") {
          let x =
            this.user.type == "1" || this.permissions.reback_fatworas == "1"
              ? true
              : false;
          return x;
        } else if (val == "sarf_card") {
          let x =
            this.user.type == "1" || this.permissions.sarf_card == "1"
              ? true
              : false;
          return x;
        } else if (val == "orders") {
          let x =
            this.user.type == "1" || this.permissions.orders == "1"
              ? true
              : false;
          return x;
        } else if (val == "tanfiz_fatworas") {
          let x =
            this.user.type == "1" || this.permissions.tanfiz_fatworas == "1"
              ? true
              : false;
          return x;
        } else if (val == "sarf_from_stores") {
          let x =
            this.user.type == "1" || this.permissions.sarf_from_stores == "1"
              ? true
              : false;
          return x;
        } else if (val == "solmt_fatworas") {
          let x =
            this.user.type == "1" || this.permissions.solmt_fatworas == "1"
              ? true
              : false;
          return x;
        } else if (val == "sell_reback") {
          let x =
            this.user.type == "1" || this.permissions.sell_reback == "1"
              ? true
              : false;
          return x;
        } else if (val == "final_fatworas") {
          let x =
            this.user.type == "1" || this.permissions.final_fatworas == "1"
              ? true
              : false;
          return x;
        } else if (val == "buy_fatworas") {
          let x =
            this.user.type == "1" || this.permissions.buy_fatworas == "1"
              ? true
              : false;
          return x;
        } else if (val == "buy_fatwora_reback") {
          let x =
            this.user.type == "1" || this.permissions.buy_fatwora_reback == "1"
              ? true
              : false;
          return x;
        } else if (val == "client_sadad") {
          let x =
            this.user.type == "1" || this.permissions.client_sadad == "1"
              ? true
              : false;
          return x;
        } else if (val == "importer_sadad") {
          let x =
            this.user.type == "1" || this.permissions.importer_sadad == "1"
              ? true
              : false;
          return x;
        } else if (val == "client_khasm") {
          let x =
            this.user.type == "1" || this.permissions.client_khasm == "1"
              ? true
              : false;
          return x;
        } else if (val == "khazina_deposit") {
          let x =
            this.user.type == "1" || this.permissions.khazina_deposit == "1"
              ? true
              : false;
          return x;
        } else if (val == "khazina_withdrew") {
          let x =
            this.user.type == "1" || this.permissions.khazina_withdrew == "1"
              ? true
              : false;
          return x;
        } else if (val == "khazina_transfer") {
          let x =
            this.user.type == "1" || this.permissions.khazina_transfer == "1"
              ? true
              : false;
          return x;
        } else if (val == "masrofat") {
          let x =
            this.user.type == "1" || this.permissions.masrofat == "1"
              ? true
              : false;
          return x;
        } else if (val == "ohda") {
          let x =
            this.user.type == "1" || this.permissions.ohda == "1"
              ? true
              : false;
          return x;
        } else if (val == "bank_deposit") {
          let x =
            this.user.type == "1" || this.permissions.bank_deposit == "1"
              ? true
              : false;
          return x;
        } else if (val == "bank_withdrew") {
          let x =
            this.user.type == "1" || this.permissions.bank_withdrew == "1"
              ? true
              : false;
          return x;
        } else if (val == "bank_transfer") {
          let x =
            this.user.type == "1" || this.permissions.bank_transfer == "1"
              ? true
              : false;
          return x;
        } else if (val == "cheques") {
          let x =
            this.user.type == "1" || this.permissions.cheques == "1"
              ? true
              : false;
          return x;
        } else if (val == "employers") {
          let x =
            this.user.type == "1" || this.permissions.employers == "1"
              ? true
              : false;
          return x;
        } else if (val == "omolas") {
          let x =
            this.user.type == "1" || this.permissions.omolas == "1"
              ? true
              : false;
          return x;
        } else if (val == "salary") {
          let x =
            this.user.type == "1" || this.permissions.salary == "1"
              ? true
              : false;
          return x;
        } else if (val == "salary_input") {
          let x =
            this.user.type == "1" || this.permissions.salary_input == "1"
              ? true
              : false;
          return x;
        } else if (val == "vacancy") {
          let x =
            this.user.type == "1" || this.permissions.vacancy == "1"
              ? true
              : false;
          return x;
        } else if (val == "attends") {
          let x =
            this.user.type == "1" || this.permissions.attends == "1"
              ? true
              : false;
          return x;
        } else if (val == "client_detail_account") {
          let x =
            this.user.type == "1" ||
            this.permissions.client_detail_account == "1"
              ? true
              : false;
          return x;
        } else if (val == "client_account") {
          let x =
            this.user.type == "1" || this.permissions.client_account == "1"
              ? true
              : false;
          return x;
        } else if (val == "importer_account") {
          let x =
            this.user.type == "1" || this.permissions.importer_account == "1"
              ? true
              : false;
          return x;
        } else if (val == "mandob_sales_report") {
          let x =
            this.user.type == "1" || this.permissions.mandob_sales_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "mandob_client_type_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.mandob_client_type_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "mandob_item_report") {
          let x =
            this.user.type == "1" || this.permissions.mandob_item_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "mandob_client_sadad_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.mandob_client_sadad_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "mandob_client_madionia_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.mandob_client_madionia_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "item_sales_report") {
          let x =
            this.user.type == "1" || this.permissions.item_sales_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "item_client_type_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.item_client_type_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "store_item_transfer_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.store_item_transfer_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "store_one_item_transfer_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.store_one_item_transfer_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "store_movement_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.store_movement_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "store_movement_all_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.store_movement_all_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "store_gard") {
          let x =
            this.user.type == "1" || this.permissions.store_gard == "1"
              ? true
              : false;
          return x;
        } else if (val == "khazina_client_sadad_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.khazina_client_sadad_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "khazina_input_detail_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.khazina_input_detail_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "masrof_all_report") {
          let x =
            this.user.type == "1" || this.permissions.masrof_all_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "masrof_with_type_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.masrof_with_type_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "khazina_input_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.khazina_input_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "barnch_sales_report") {
          let x =
            this.user.type == "1" || this.permissions.barnch_sales_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "company_sales_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.company_sales_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "branch_madionia_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.branch_madionia_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "company_madionia_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.company_madionia_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "user_behavior_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.user_behavior_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "employer_salary_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.employer_salary_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "employer_omola_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.employer_omola_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "khazina_importer_sadad_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.khazina_importer_sadad_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "item_buy_report") {
          let x =
            this.user.type == "1" || this.permissions.item_buy_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "reback_sell_all") {
          let x =
            this.user.type == "1" || this.permissions.reback_sell_all == "1"
              ? true
              : false;
          return x;
        } else if (val == "reback_buy_all") {
          let x =
            this.user.type == "1" || this.permissions.reback_buy_all == "1"
              ? true
              : false;
          return x;
        } else if (val == "reback_item_buy_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.reback_item_buy_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "reback_client_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.reback_client_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "reback_mandob_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.reback_mandob_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "reback_item_report") {
          let x =
            this.user.type == "1" || this.permissions.reback_item_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "reback_importer_report") {
          let x =
            this.user.type == "1" ||
            this.permissions.reback_importer_report == "1"
              ? true
              : false;
          return x;
        } else if (val == "AddNewClient") {
          let x =
            this.user.type == "1" || this.permissions.AddNewClient == "1"
              ? true
              : false;
          return x;
        } else if (val == "mandobVisits") {
          let x =
            this.user.type == "1" || this.permissions.mandobVisits == "1"
              ? true
              : false;
          return x;
        } else if (val == "Tasks") {
          let x =
            this.user.type == "1" || this.permissions.Tasks == "1"
              ? true
              : false;
          return x;
        } else if (val == "Tahsilat") {
          let x =
            this.user.type == "1" || this.permissions.Tahsilat == "1"
              ? true
              : false;
          return x;
        } else if (val == "Track") {
          let x =
            this.user.type == "1" || this.permissions.Track == "1"
              ? true
              : false;
          return x;
        } else if (val == "offers") {
          let x =
            this.user.type == "1" || this.permissions.offers == "1"
              ? true
              : false;
          return x;
        } else if (val == "client_users") {
          let x =
            this.user.type == "1" || this.permissions.client_users == "1"
              ? true
              : false;
          return x;
        } else if (val == "supervisor_orders") {
          let x =
            this.user.type == "1" || this.permissions.supervisor_orders == "1"
              ? true
              : false;
          return x;
        } else if (val == "buy_confirmation") {
          let x =
            this.user.type == "1" || this.permissions.buy_confirmation == "1"
              ? true
              : false;
          return x;
        } else if (val == "badalat") {
          let x =
            this.user.type == "1" || this.permissions.badalat == "1"
              ? true
              : false;
          return x;
        } else if (val == "hafez") {
          let x =
            this.user.type == "1" || this.permissions.hafez == "1"
              ? true
              : false;
          return x;
        } else if (val == "solfa") {
          let x =
            this.user.type == "1" || this.permissions.solfa == "1"
              ? true
              : false;
          return x;
        } else if (val == "khasm") {
          let x =
            this.user.type == "1" || this.permissions.khasm == "1"
              ? true
              : false;
          return x;
        } else if (val == "mandob_target") {
          let x =
            this.user.type == "1" || this.permissions.mandob_target == "1"
              ? true
              : false;
          return x;
        } else if (val == "global_reback") {
          let x =
            this.user.type == "1" || this.permissions.global_reback == "1"
              ? true
              : false;
          return x;
        } else if (val == "supervisor_page") {
          let x =
            this.user.type == "1" || this.permissions.supervisor_page == "1"
              ? true
              : false;
          return x;
        } else if (val == "all_profit") {
          let x =
            this.user.type == "1" || this.permissions.all_profit == "1"
              ? true
              : false;
          return x;
        } else if (val == "item_profit") {
          let x =
            this.user.type == "1" || this.permissions.item_profit == "1"
              ? true
              : false;
          return x;
        } else if (val == "TaxFatwora") {
          let x =
            this.user.type == "1" || this.permissions.TaxFatwora == "1"
              ? true
              : false;
          return x;
        }
      };
    },

    getName() {
      var name = this.$route.name;
      return this.names[name];
    }
  },
  created() {
    this.names = names;
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));

    var frmdata = new FormData();
    notification_sms(frmdata).then(response => {
      this.orders_not_seen = response.data.orders;
      this.tahsils = response.data.tahsils;
      this.fatworas_tanfiz = response.data.fatworas_tanfiz;
      this.fatworas_sarf_store = response.data.fatworas_sarf_store;
      this.fatworas_taslim = response.data.fatworas_taslim;
      this.fatworas_solmt = response.data.fatworas_solmt;
      this.notify_not_sent = response.data.notify_not_sent;
      this.sms_not_seen_no = response.data.sms_not_seen;
      this.logs_not_seen = response.data.logs_not_seen;
      this.logs_seen = response.data.logs_seen;
      this.notify_not_sent = response.data.logs_not_sent;
      for (let index = 0; index < this.notify_not_sent.length; index++) {
        this.$toastr.warning(
          this.notify_not_sent[index].body,
          this.notify_not_sent[index].title,
          {
            closeButton: true,
            progressBar: true,
            positionClass: "toast-bottom-left",
            preventDuplicates: false,
            timeOut: "60000"
          }
        );
      }
    });

    window.setInterval(() => {
      var frmdata = new FormData();
      notification_sms(frmdata).then(response => {
        this.orders_not_seen = response.data.orders;
        this.tahsils = response.data.tahsils;
        this.fatworas_tanfiz = response.data.fatworas_tanfiz;
        this.fatworas_sarf_store = response.data.fatworas_sarf_store;
        this.fatworas_taslim = response.data.fatworas_taslim;
        this.fatworas_solmt = response.data.fatworas_solmt;
        this.sms_not_seen_no = response.data.sms_not_seen;
        this.logs_not_seen = response.data.logs_not_seen;
        this.logs_seen = response.data.logs_seen;
        this.notify_not_sent = response.data.logs_not_sent;
        for (let index = 0; index < this.notify_not_sent.length; index++) {
          this.$toastr.warning(
            this.notify_not_sent[index].body,
            this.notify_not_sent[index].title,
            {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "300000"
            }
          );
        }
      });
    }, 100000);
  }
};
</script>

<style>
.v-navigation-drawer {
  text-align: center;
}
.v-list__tile__title {
  text-align: right;
}
.v-icon {
  margin-left: 0px;
}
.v-treeview-node__toggle {
  display: none;
}
.v-list__group__items.v-list__group__items--no-action > div {
  width: 100%;
}
.v-badge__badge {
  font-size: 12px;
  top: -2px;
  right: -5px;
  height: 15px;
  width: 15px;
}
.v-badge {
  cursor: pointer;
}
.toast-container,
.toast-title,
.toast-message {
  color: black !important;
}

.notification {
  width: 500px;
  height: 250px;
  position: absolute;
  top: 0px;
  left: 61px;
  z-index: 111;
  background: rgba(255, 152, 0, 0.7);
  transition: all 3.5s ease;
  direction: rtl;
  padding: 6px;
  border-radius: 0px 0px 21px 21px;
  overflow-y: auto;
  overflow-x: hidden;
}
.v-list__group__items {
  position: absolute;
  top: -70px;
  right: 335px;
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 400px;
}
.v-navigation-drawer.v-navigation-drawer--fixed {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 100%;
  margin-top: 0px;
  /* max-height: calc(90% - 171px); */
  transform: translateX(0px);
  width: 362px;
}

.new_items_upper {
  position: fixed;
  right: 360px;
  top: 113px;
  background-color: #ffbc00;
  font-size: 22px;
  text-align: right;
  z-index: 3;
  border-radius: 20px 0px 0px 20px;
  box-shadow: -4px -5px 5px #ccc;
}
.new_items {
  list-style: none;
}
.new_items li {
  cursor: pointer;
  padding: 5px 10px 0px 20px;
  -moz-box-shadow: inset 0 0 10px #21411f;
  -webkit-box-shadow: inset 0 0 10px #21411f;
  box-shadow: inset 0 0 10px #21411f;
}
.new_items li:first-child {
  border-radius: 20px 0px 0px 0px;
}
.new_items li:last-child {
  border-radius: 0px 0px 0px 20px;
}
.new_items li a {
  text-decoration: none;
  font-family: "Aref Ruqaa";
  color: black;
  /* font-weight: bold; */
}
.v-list > div {
  box-shadow: inset 0 0 10px #21411f;
}
</style>
